(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 34822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$_": function() { return /* binding */ startingStackAtom; },
/* harmony export */   "fm": function() { return /* binding */ avgCostPerBTCPriceAtom; }
/* harmony export */ });
/* unused harmony export isSatoshis */
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15103);

var startingStackAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(0);
var avgCostPerBTCPriceAtom = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(0);
var isSatoshis = (0,jotai__WEBPACK_IMPORTED_MODULE_0__/* .atom */ .cn)(true);

/***/ }),

/***/ 9363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cH": function() { return /* binding */ Disconnect; }
/* harmony export */ });
/* unused harmony exports RightArrow, LeftArrow */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


var RightArrow = function RightArrow() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "39.844",
    height: "31.875",
    viewBox: "0 0 39.844 31.875",
    children: /*#__PURE__*/_jsxs("g", {
      transform: "translate(-254.773 -1717.785)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M278.681,1749.66a1.992,1.992,0,0,1-1.409-3.4l12.537-12.537-12.537-12.537a1.992,1.992,0,1,1,2.817-2.817l13.943,13.942a2,2,0,0,1,0,2.82l-13.945,13.945A1.966,1.966,0,0,1,278.681,1749.66Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M292.624,1735.71H256.765a1.992,1.992,0,1,1,0-3.984h35.859a1.992,1.992,0,1,1,0,3.984Z"
      })]
    })
  });
};
var LeftArrow = function LeftArrow() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "39.844",
    height: "31.875",
    viewBox: "0 0 39.844 31.875",
    children: /*#__PURE__*/_jsxs("g", {
      transform: "translate(294.617 1749.66) rotate(180)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M278.681,1749.66a1.992,1.992,0,0,1-1.409-3.4l12.537-12.537-12.537-12.537a1.992,1.992,0,1,1,2.817-2.817l13.943,13.942a2,2,0,0,1,0,2.82l-13.945,13.945A1.966,1.966,0,0,1,278.681,1749.66Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M292.624,1735.71H256.765a1.992,1.992,0,1,1,0-3.984h35.859a1.992,1.992,0,1,1,0,3.984Z"
      })]
    })
  });
};
var Disconnect = function Disconnect() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
      clipPath: "url(#clip0_651_490)",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
        clipPath: "url(#clip1_651_490)",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
          d: "M6.11719 6.74939L8.66103 4.20546L9.39474 4.93914L6.85089 7.48307L6.11719 6.74939Z",
          fill: "currentColor"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
          d: "M8.66038 4.48839L9.11118 4.93919L6.85038 7.19999L6.39958 6.74919L8.66038 4.48839ZM8.66038 3.92279L8.37758 4.20559L6.11678 6.46639L5.83398 6.74919L6.11678 7.03199L6.56758 7.48279L6.85038 7.76559L7.13318 7.48279L9.39398 5.22199L9.67678 4.93919L9.39398 4.65639L8.94318 4.20559L8.66038 3.92279Z",
          fill: "#565656"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
          d: "M8.51758 9.14941L11.0614 6.60548L11.7951 7.33916L9.25129 9.8831L8.51758 9.14941Z",
          fill: "currentColor"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
          d: "M11.0608 6.88842L11.5116 7.33921L9.25078 9.60001L8.79997 9.14921L11.0608 6.88842ZM11.0608 6.32281L10.778 6.60561L8.51717 8.86641L8.23438 9.14921L8.51717 9.43201L8.96797 9.88281L9.25078 10.1656L9.53357 9.88281L11.7944 7.62201L12.0772 7.33921L11.7944 7.05642L11.3436 6.60561L11.0608 6.32281Z",
          fill: "#565656"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
          d: "M8.17578 3.14482L10.1046 1.21602C10.4646 0.85642 10.943 0.65802 11.4518 0.65802C11.9606 0.65802 12.439 0.85642 12.799 1.21602L13.3326 1.75002L14.4006 0.68282L15.3178 1.60002L14.2506 2.66722L14.7846 3.20082C15.5274 3.94362 15.5274 5.15242 14.7846 5.89562L12.8558 7.82442L8.17578 3.14482Z",
          fill: "currentColor"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
          d: "M11.4518 0.858024C11.9074 0.858024 12.3354 1.03522 12.6578 1.35762L13.0502 1.75002L13.333 2.03282L13.6158 1.75002L14.4002 0.965624L15.0346 1.60002L14.2502 2.38442L13.9674 2.66722L14.2502 2.95002L14.6426 3.34242C14.9646 3.66442 15.1422 4.09282 15.1422 4.54842C15.1422 5.00402 14.965 5.43202 14.6426 5.75442L12.8554 7.54162L8.45858 3.14482L10.2458 1.35762C10.5678 1.03562 10.9962 0.858024 11.4518 0.858024ZM14.4002 0.400024L13.333 1.46722L12.9402 1.07482C12.529 0.663624 11.9902 0.458024 11.4514 0.458024C10.9126 0.458024 10.3738 0.663624 9.96258 1.07482L7.89258 3.14482L12.855 8.10722L14.925 6.03722C15.7474 5.21522 15.7474 3.88202 14.925 3.05962L14.5326 2.66722L15.6002 1.60002L14.4002 0.400024Z",
          fill: "#565656"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
          d: "M6.53711 3.93842L7.36351 3.11162C7.62111 2.85402 7.95071 2.70642 8.26791 2.70642C8.49271 2.70642 8.68551 2.78122 8.82671 2.92202L13.0787 7.17402C13.4295 7.52522 13.3447 8.18162 12.8887 8.63722L12.0619 9.46362L6.53711 3.93842Z",
          fill: "currentColor"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
          d: "M8.26791 2.90641C8.38671 2.90641 8.55591 2.93361 8.68551 3.06321L12.9375 7.31521C13.2059 7.58361 13.1191 8.12441 12.7475 8.49561L12.0623 9.18081L6.81951 3.93841L7.50471 3.25321C7.72191 3.03601 8.00711 2.90641 8.26791 2.90641ZM8.26791 2.50641C7.91311 2.50641 7.52711 2.66521 7.22191 2.97041L6.25391 3.93841L12.0623 9.74681L13.0303 8.77881C13.5651 8.24401 13.6499 7.46241 13.2203 7.03281L8.96831 2.78081C8.78391 2.59601 8.53431 2.50641 8.26791 2.50641Z",
          fill: "#565656"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
          d: "M4.47153 15.4192C3.96273 15.4192 3.48433 15.2208 3.12433 14.8612L2.59073 14.3272L1.60033 15.3172L0.683131 14.4L1.67313 13.41L1.13913 12.876C0.396331 12.1332 0.396331 10.9244 1.13913 10.1812L3.06793 8.25238L7.74753 12.932L5.81873 14.8608C5.45873 15.2208 4.98033 15.4192 4.47153 15.4192Z",
          fill: "currentColor"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
          d: "M3.06766 8.53557L7.46446 12.9324L5.67726 14.7196C5.35526 15.0416 4.92686 15.2192 4.47126 15.2192C4.01566 15.2192 3.58766 15.042 3.26526 14.7196L2.87286 14.3272L2.59006 14.0444L2.30726 14.3272L1.60006 15.0344L0.965659 14.4L1.67286 13.6928L1.95566 13.41L1.67286 13.1272L1.28046 12.7348C0.615659 12.07 0.615659 10.988 1.28046 10.3228L3.06766 8.53557ZM3.06766 7.96997L0.997659 10.04C0.175259 10.8624 0.175259 12.1952 0.997659 13.0176L1.39006 13.41L0.400059 14.4L1.60006 15.6L2.59006 14.61L2.98246 15.0024C3.39366 15.4136 3.93246 15.6192 4.47126 15.6192C5.01006 15.6192 5.54886 15.4136 5.96006 15.0024L8.03006 12.9324L3.06766 7.96997Z",
          fill: "#565656"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
          d: "M7.71241 13.404C7.47681 13.404 7.25841 13.3156 7.09801 13.1552L2.84601 8.90318C2.49521 8.55198 2.51881 7.95718 2.89921 7.57678L3.58921 6.88678L9.11481 12.412L8.42481 13.102C8.23281 13.294 7.97321 13.404 7.71241 13.404Z",
          fill: "currentColor"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
          d: "M3.58821 7.1696L8.83101 12.4124L8.28261 12.9608C8.12781 13.1156 7.91981 13.204 7.71181 13.204C7.52941 13.204 7.36141 13.1364 7.23861 13.0136L2.98661 8.7616C2.71341 8.4884 2.73741 8.0204 3.03981 7.718L3.58821 7.1696ZM3.58821 6.604L2.75701 7.4352C2.29781 7.8944 2.27421 8.6148 2.70381 9.0448L6.95581 13.2968C7.16141 13.5024 7.43341 13.604 7.71181 13.604C8.01541 13.604 8.32581 13.4828 8.56541 13.2436L9.39661 12.4124L3.58821 6.604Z",
          fill: "#565656"
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
        id: "clip0_651_490",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
          width: "16",
          height: "16",
          fill: "white"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
        id: "clip1_651_490",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
          width: "16",
          height: "16",
          fill: "white"
        })
      })]
    })]
  });
};

/***/ }),

/***/ 61256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4730);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71383);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33546);
/* harmony import */ var rehype_raw__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39234);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46133);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);



var _excluded = ["children", "className", "onPrimaryBg"],
    _excluded2 = ["node", "children", "href"];

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var StyledA = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a */ .ZP.a(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(["\n  color: ", ";\n  text-decoration: underline;\n\n  &:hover {\n    color: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme,
      $onPrimaryBg = _ref.$onPrimaryBg;
  return $onPrimaryBg ? theme.colors.linkColours.main : theme.colors.primary;
}, function (_ref2) {
  var theme = _ref2.theme,
      $onPrimaryBg = _ref2.$onPrimaryBg;
  return $onPrimaryBg ? theme.colors.linkColours.mainHover : theme.colors.text;
});
var StyledReactMarkdown = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(react_markdown__WEBPACK_IMPORTED_MODULE_6__/* .ReactMarkdown */ .D)(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(["\n  line-height: 1.6;\n  font-size: 1.6rem;\n  @media screen and (max-width: ", ") {\n    font-size: 1.5rem;\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.sm.maxWidth;
});

var MarkdownText = function MarkdownText(_ref4) {
  var children = _ref4.children,
      _ref4$className = _ref4.className,
      className = _ref4$className === void 0 ? '' : _ref4$className,
      onPrimaryBg = _ref4.onPrimaryBg,
      props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref4, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledReactMarkdown, _objectSpread(_objectSpread({}, props), {}, {
    className: "markdown-text-wrapper ".concat(className),
    rehypePlugins: [rehype_raw__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z],
    components: {
      a: function a(_ref5) {
        var node = _ref5.node,
            children = _ref5.children,
            href = _ref5.href,
            aProps = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref5, _excluded2);

        var isExternal = href.startsWith('http');
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
          href: href,
          passHref: true,
          legacyBehavior: true,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledA, _objectSpread(_objectSpread({}, aProps), {}, {
            target: isExternal ? '_blank' : undefined,
            rel: isExternal ? 'noopener' : undefined,
            $onPrimaryBg: onPrimaryBg,
            children: children
          }))
        });
      }
    },
    children: children
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (MarkdownText);

/***/ }),

/***/ 93138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useCalculation; },
/* harmony export */   "u": function() { return /* binding */ CalculationContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var CalculationContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
var useCalculation = function useCalculation() {
  return react__WEBPACK_IMPORTED_MODULE_0__.useContext(CalculationContext);
};

/***/ }),

/***/ 51731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ validateGoal; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66688);
/* harmony import */ var components_atoms_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6427);
/* harmony import */ var utils_convertBtcSats__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72583);
/* harmony import */ var _utils_logicContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73839);
/* harmony import */ var _utils_currency__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92442);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var convertedText = function convertedText(isSatoshis, goal) {
  if (isSatoshis) {
    return "= ".concat(goal ? (0,utils_convertBtcSats__WEBPACK_IMPORTED_MODULE_3__/* .convertValue */ .Ai)(true, false, goal).toLocaleString(undefined, {
      maximumFractionDigits: 8
    }) : '?', " BTC");
  } else {
    return "= ".concat(goal ? (0,utils_convertBtcSats__WEBPACK_IMPORTED_MODULE_3__/* .convertValue */ .Ai)(false, true, goal).toLocaleString(undefined, {
      maximumFractionDigits: 0
    }) : '?', " sats");
  }
};

var validateGoal = function validateGoal(_ref, inputsProps, _ref2) {
  var value = _ref.goal,
      isSatoshis = _ref.isSatoshis;
  var satsLimit = _ref2.satsLimit,
      BTCLimit = _ref2.BTCLimit,
      currentStack = _ref2.currentStack;
  value = Number.parseFloat(value);
  if (!value) return 'Must specify a number';
  if (value < 0) return 'Must not be a negative number';
  if (value <= currentStack) return 'SatsGoal must be greater than starting stack';
  if (!isSatoshis && value > BTCLimit) return inputsProps.goalAmountBTCOverLimitError;
  if (isSatoshis && value > satsLimit) return inputsProps.goalAmountSatsOverLimitError;
};

var GoalField = function GoalField(_ref3) {
  var inputsData = _ref3.inputsData;

  var _useFormState = (0,react_final_form__WEBPACK_IMPORTED_MODULE_1__.useFormState)(),
      _useFormState$values = _useFormState.values,
      goal = _useFormState$values.goal,
      isSatoshis = _useFormState$values.isSatoshis,
      errors = _useFormState.errors;

  var logic = (0,_utils_logicContext__WEBPACK_IMPORTED_MODULE_4__/* .useLogic */ .Z)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_1__.Field, {
    name: "goal",
    type: "number",
    initialValue: inputsData.defaults.goalSats,
    children: function children(_ref4) {
      var input = _ref4.input,
          meta = _ref4.meta;
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_form__WEBPACK_IMPORTED_MODULE_2__.StyledField, {
        id: "goal",
        label: inputsData.goalAmountLabel,
        error: meta.error,
        help: inputsData.helpTexts.goal,
        supplementaryText: convertedText(isSatoshis, goal),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_form__WEBPACK_IMPORTED_MODULE_2__.FormattedInput, _objectSpread(_objectSpread({}, input), {}, {
          id: "goal",
          step: isSatoshis ? 1 : 0.00000001,
          min: isSatoshis ? 1 : 0.00000001,
          max: isSatoshis ? 1 * logic.SatsSupplyLimit : 1 * logic.BTCSupplyLimit,
          format: function format(val) {
            return "".concat(val ? (0,_utils_currency__WEBPACK_IMPORTED_MODULE_5__/* .numberWithCommas */ .x6)(val) : 0, " ").concat((0,_utils_currency__WEBPACK_IMPORTED_MODULE_5__/* .getUnitName */ .ij)(val, isSatoshis));
          },
          $error: meta.error
        }))
      });
    }
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (GoalField);

/***/ }),

/***/ 52816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TitleH1 */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16835);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71383);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46133);
/* harmony import */ var _atoms_markdown__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61256);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;





var GradientText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span */ .ZP.span(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  background: ", ";\n  background-clip: text;\n  -webkit-background-clip: text;\n  color: transparent;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primaryGradient;
});
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  gap: 3rem;\n  margin-bottom: ", ";\n\n  @media screen and (max-width: ", ") {\n    padding: 0 1rem;\n    margin-bottom: ", ";\n  }\n"])), function (_ref2) {
  var $marginBottom = _ref2.$marginBottom;
  return $marginBottom ? $marginBottom : 0;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref4) {
  var $marginBottom = _ref4.$marginBottom;
  return $marginBottom ? "calc(".concat($marginBottom, " / 2)") : 0;
});
var Inner = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div(_templateObject3 || (_templateObject3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  gap: 3rem;\n"])));
var Description = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p */ .ZP.p(_templateObject4 || (_templateObject4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  text-align: center;\n  margin: initial;\n  font-weight: initial;\n  line-height: 1.6;\n  font-size: 1.6rem;\n  font-weight: 500;\n  @media screen and (max-width: ", ") {\n    font-size: 1.5rem;\n  }\n  color: ", ";\n\n  max-width: 800px;\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.text;
});
var TitleH1 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h1 */ .ZP.h1(_templateObject5 || (_templateObject5 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  text-align: center;\n  font-size: 46px;\n  @media screen and (max-width: ", ") {\n    font-size: 3rem;\n  }\n  color: ", ";\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.typography.headingFontFamily;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.text;
});
var StyledMarkdownContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div(_templateObject6 || (_templateObject6 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(["\n  max-width: 800px;\n  text-align: center;\n  p {\n    font-family: Inter, sans-serif;\n    text-align: center;\n    margin: initial;\n    line-height: 1.6;\n    font-size: 1.6rem;\n    font-weight: 500;\n    color: ", ";\n    max-width: 800px;\n  }\n"])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.text;
});

var PageTitle = function PageTitle(_ref12) {
  var title = _ref12.title,
      description = _ref12.description,
      $marginBottom = _ref12.$marginBottom;

  var _split = (title || '').split('<gradient>'),
      _split2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_split, 3),
      before = _split2[0],
      gradientText = _split2[1],
      after = _split2[2];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
    $marginBottom: $marginBottom,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Inner, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TitleH1, {
        children: [before, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(GradientText, {
          children: gradientText
        }), after]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledMarkdownContainer, {
        style: {},
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms_markdown__WEBPACK_IMPORTED_MODULE_0__["default"], {
          children: description
        })
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PageTitle);

/***/ }),

/***/ 28035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var SEO = function SEO(_ref) {
  var _openGraphImage$data;

  var propTitle = _ref.title,
      metaTitle = _ref.metaTitle,
      metaDescription = _ref.metaDescription,
      twitterCard = _ref.twitterCard,
      twitterSite = _ref.twitterSite,
      twitterCreator = _ref.twitterCreator,
      openGraphImage = _ref.openGraphImage,
      noindex = _ref.noindex,
      jsonSchema = _ref.jsonSchema;
  var title = propTitle || metaTitle;
  var ogImage = openGraphImage === null || openGraphImage === void 0 ? void 0 : (_openGraphImage$data = openGraphImage.data) === null || _openGraphImage$data === void 0 ? void 0 : _openGraphImage$data.attributes;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("title", {
        children: title
      }, "title"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:title",
        content: title
      }, "og:title")]
    }), metaDescription && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        name: "description",
        content: metaDescription
      }, "description"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        name: "twitter:description",
        content: metaDescription
      }, "twitter:description")]
    }), twitterCard && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      name: "twitter:card",
      content: twitterCard
    }, "twitter:card"), twitterSite && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      name: "twitter:site",
      content: twitterSite
    }, "twitter:site"), twitterCreator && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      name: "twitter:creator",
      content: twitterCreator
    }, "twitter:creator"), ogImage && (ogImage === null || ogImage === void 0 ? void 0 : ogImage.url) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:image",
        content: ogImage.url
      }, "og:image"), ogImage.width && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:image:width",
        content: ogImage.width
      }, "og:image:width"), ogImage.height && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:image:height",
        content: ogImage.height
      }, "og:image:height"), ogImage.alternativeText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:image:alt",
        content: ogImage.alternativeText
      }, "og:image:alt"), ogImage.mime && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
        property: "og:image:type",
        content: ogImage.mime
      }, "og:image:type")]
    }), jsonSchema && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("script", {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(jsonSchema)
      }
    }, "jsonSchema"), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta", {
      property: "robots",
      content: noindex ? 'noindex' : 'index follow'
    }, "robots")]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SEO);

/***/ }),

/***/ 74956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/atomic-layout/lib/esm/index.js
var esm = __webpack_require__(19010);
// EXTERNAL MODULE: ./components/layout/pageTitle.js
var pageTitle = __webpack_require__(52816);
// EXTERNAL MODULE: ./components/seo.js
var seo = __webpack_require__(28035);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./utils/utils.js
var utils = __webpack_require__(91851);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(46133);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/content/calculator/inputs/goal.js
var goal = __webpack_require__(51731);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./components/atoms/form/index.js + 2 modules
var atoms_form = __webpack_require__(6427);
// EXTERNAL MODULE: ./components/content/calculator/calculationContext.js
var calculationContext = __webpack_require__(93138);
// EXTERNAL MODULE: ./components/atoms/Buttons.js
var Buttons = __webpack_require__(87314);
// EXTERNAL MODULE: ./components/atoms/SVG.js
var SVG = __webpack_require__(9363);
// EXTERNAL MODULE: ./node_modules/react-mitt/dist/react-mitt.es.js
var react_mitt_es = __webpack_require__(75492);
// EXTERNAL MODULE: ./utils/convertBtcSats.js
var convertBtcSats = __webpack_require__(72583);
// EXTERNAL MODULE: ./utils/logicContext.js
var logicContext = __webpack_require__(73839);
// EXTERNAL MODULE: ./utils/currency.js
var currency = __webpack_require__(92442);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/content/calculator/inputs/currentStack.js



var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var StyledField = (0,styled_components_browser_esm/* default */.ZP)(atoms_form.StyledField)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: relative;\n"])));
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Buttons/* Button */.zx)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  min-height: unset;\n  height: unset;\n  position: absolute;\n  top: -4px;\n  right: 3.5rem;\n  font-weight: 800;\n  padding: 0.27rem 1.1rem;\n  font-size: 1.2rem;\n  font-family: 'Inter', sans-serif;\n  line-height: 1.7;\n  border-radius: 3rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  transition: 300ms all;\n  &:hover {\n    background: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primaryHover;
});
var validateCurrentStack = function validateCurrentStack(_ref2, inputsProps, _ref3) {
  var goal = _ref2.goal,
      value = _ref2.currentStack,
      isSatoshis = _ref2.isSatoshis;
  var satsLimit = _ref3.satsLimit,
      BTCLimit = _ref3.BTCLimit,
      checkGoal = _ref3.checkGoal;
  // if (value === '' || value === undefined) return 'Required'
  if (value < 0) return 'Must not be a negative number';
  if (!isSatoshis && Number.parseFloat(value) > Number.parseFloat(BTCLimit)) return inputsProps.goalAmountBTCOverLimitError;
  if (isSatoshis && Number.parseFloat(value) > Number.parseFloat(satsLimit)) return inputsProps.goalAmountSatsOverLimitError;

  if (checkGoal && Number.parseFloat(value) > Number.parseFloat(goal)) {
    return 'Current stack cannot be more than the goal';
  }
};

var CurrentStackField = function CurrentStackField(_ref4) {
  var inputsData = _ref4.inputsData,
      workOfflineSection = _ref4.workOfflineSection;

  var _useCalculation = useCalculation(),
      goal = _useCalculation.goal,
      useStackingAmount = _useCalculation.useStackingAmount;

  var logic = useLogic();

  var _useMitt = useMitt(),
      emitter = _useMitt.emitter;

  var _useFormState = useFormState(),
      values = _useFormState.values,
      errors = _useFormState.errors;

  var _useForm = useForm(),
      change = _useForm.change;

  var isSatoshis = values.isSatoshis;

  var _useState = useState(values),
      oldValues = _useState[0],
      setOldValues = _useState[1];

  var _useState2 = useState(),
      currentStackValue = _useState2[0],
      setCurrentStackValue = _useState2[1];

  useEffect(function () {
    change('currentStack', 0);
  }, []);
  useEffect(function () {
    if (oldValues.isSatoshis != values.isSatoshis) {
      if (values.isSatoshis) {
        change('currentStack', toSat(values.currentStack));
        setCurrentStackValue(function (oldVal) {
          return toSat(oldVal);
        });
      } else {
        change('currentStack', toBTC(values.currentStack));
        setCurrentStackValue(function (oldVal) {
          return toBTC(oldVal);
        });
      }

      setOldValues(values);
    }
  }, [values]);

  var format = function format(val) {
    val = scientificToNumber(val || 0);
    return "".concat(numberWithCommas(val), " ").concat(getUnitName(val, isSatoshis));
  };

  var _onChange = function onChange(val) {
    setCurrentStackValue(val);
  }; // if (isSatoshis && Number(val) > 1 * logic.SatsSupplyLimit) return 'sats limit'
  //               if (!isSatoshis && Number(val) > 1 * logic.BTCSupplyLimit) return 'btc limit'
  // const isCurrentStackError = () => {
  //   if (goal && !useStackingAmount) return startingStack > goal;
  //   if (isSatoshis) return startingStack > 1 * logic.SatsSupplyLimit
  //   return startingStack > 1 * logic.BTCSupplyLimit;
  // };
  // const isError = () => {
  //   if ()
  // }


  return /*#__PURE__*/_jsx(Field, {
    name: "currentStack",
    type: "number",
    validate: function validate(val) {
      if (Number(val) < 0) return "Value cannot be negative.";
    },
    children: function children(_ref5) {
      var input = _ref5.input,
          meta = _ref5.meta;
      return /*#__PURE__*/_jsxs(StyledField, {
        label: inputsData.currentStackLabel,
        error: meta.touched && meta.error,
        help: inputsData.helpTexts.stackingAmount // Change it
        ,
        children: [/*#__PURE__*/_jsxs(StyledButton, {
          onClick: function onClick() {
            return emitter.emit('show-offline-modal');
          },
          $primary: true,
          children: [/*#__PURE__*/_jsx(Disconnect, {}), workOfflineSection === null || workOfflineSection === void 0 ? void 0 : workOfflineSection.buttonText]
        }), /*#__PURE__*/_jsx(FormattedInput, _objectSpread(_objectSpread({}, input), {}, {
          forcedDefault: '',
          type: "number",
          noNegative: true,
          value: currentStackValue,
          noFraction: isSatoshis,
          onChange: function onChange(e) {
            _onChange(e.target.value);

            input.onChange(e);
          },
          forceNumeric: true,
          id: "currentStackInput",
          step: isSatoshis ? 1 : 0.00000001,
          min: useStackingAmount || !goal ? isSatoshis ? 1 : 0.00000001 : goal,
          max: useStackingAmount || !goal ? isSatoshis ? 1 * logic.SatsSupplyLimit : 1 * logic.BTCSupplyLimit : goal,
          format: format,
          $error: meta.touched && meta.error
        }))]
      });
    }
  });
};

/* harmony default export */ var currentStack = ((/* unused pure expression or super */ null && (CurrentStackField)));
// EXTERNAL MODULE: ./node_modules/jotai/esm/react.mjs
var esm_react = __webpack_require__(48583);
// EXTERNAL MODULE: ./atoms/calculator.js
var calculator = __webpack_require__(34822);
;// CONCATENATED MODULE: ./pages/index.js




var pages_templateObject;

function pages_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function pages_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? pages_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : pages_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

















var BitcoinValueBox = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 640).then(__webpack_require__.bind(__webpack_require__, 74640));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      style: {
        height: '100px'
      }
    });
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(74640)];
    }
  }
});
var CTAComponent = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 859).then(__webpack_require__.bind(__webpack_require__, 62859));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(62859)];
    }
  }
});
var Calculation = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(573), __webpack_require__.e(104), __webpack_require__.e(474)]).then(__webpack_require__.bind(__webpack_require__, 9474));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9474)];
    }
  }
});
var CalculatorInputs = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(813), __webpack_require__.e(573), __webpack_require__.e(403)]).then(__webpack_require__.bind(__webpack_require__, 19403));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(19403)];
    }
  }
});
var EmailSignupComponent = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 168).then(__webpack_require__.bind(__webpack_require__, 8168));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(8168)];
    }
  }
});
var GlassBox = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 337).then(__webpack_require__.bind(__webpack_require__, 65337));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      style: {
        height: '650px'
      }
    });
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(65337)];
    }
  }
});
var GraphsComponent = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(813), __webpack_require__.e(431), __webpack_require__.e(451)]).then(__webpack_require__.bind(__webpack_require__, 9451));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9451)];
    }
  }
});
var LatestBlogComponent = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(813), __webpack_require__.e(274)]).then(__webpack_require__.bind(__webpack_require__, 14274));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(14274)];
    }
  }
});
var Modal = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 37).then(__webpack_require__.bind(__webpack_require__, 60037));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(60037)];
    }
  }
});
var PredictionInputs = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(813), __webpack_require__.e(573), __webpack_require__.e(952)]).then(__webpack_require__.bind(__webpack_require__, 61952));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(61952)];
    }
  }
});
var SingleStatsComponent = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 809).then(__webpack_require__.bind(__webpack_require__, 9809));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9809)];
    }
  }
});
var SummaryTextComponent = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(813), __webpack_require__.e(649)]).then(__webpack_require__.bind(__webpack_require__, 39649));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(39649)];
    }
  }
});
var TableComponent = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(813), __webpack_require__.e(472)]).then(__webpack_require__.bind(__webpack_require__, 97472));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(97472)];
    }
  }
});
var Form = dynamic_default()( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
  return regenerator_default().wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 66688));

        case 2:
          return _context.abrupt("return", _context.sent.Form);

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})), {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(66688)];
    }
  }
});
var areasMobile = "\nbitcoinValue\ninputs\nsummaryText\ngraph\nsingleStats\ncallToAction\ntableOutput\nlatestBlog\nemailSignup\n";

var areasTablet = function areasTablet(_ref2) {
  var ctaSection = _ref2.ctaSection;
  return "\ninputs      inputs        bitcoinValue      bitcoinValue\ninputs      inputs        summaryText       summaryText\ninputs      inputs        singleStats       singleStats\ninputs      inputs        ".concat(ctaSection !== null && ctaSection !== void 0 && ctaSection.visible ? 'callToAction  callToAction' : 'singleStats  singleStats', "\ngraph       graph         graph             graph\ntableOutput tableOutput   tableOutput       tableOutput\nlatestBlog  latestBlog    latestBlog        latestBlog\nemailSignup emailSignup   emailSignup       emailSignup\n");
};

var areasDesktop = function areasDesktop(_ref3) {
  var ctaSection = _ref3.ctaSection;
  return "\ninputs        graph         graph\nbitcoinValue  summaryText   ".concat(ctaSection !== null && ctaSection !== void 0 && ctaSection.visible ? 'callToAction' : 'summaryText', "\nsingleStats   tableOutput   tableOutput\nlatestBlog    latestBlog    latestBlog\nemailSignup   emailSignup   emailSignup\n");
};

var StyledComposition = (0,styled_components_browser_esm/* default */.ZP)(esm/* Composition */.fS)(pages_templateObject || (pages_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 1rem;\n  padding-bottom: 0;\n  box-sizing: border-box;\n  row-gap: 3rem;\n  @media screen and (min-width: ", ") {\n    row-gap: 5rem;\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.lg.minWidth;
});
var __N_SSG = true;
function Home(_ref5) {
  var seoData = _ref5.seoData,
      heroData = _ref5.heroData,
      inputsData = _ref5.inputsData,
      outputsProps = _ref5.outputsProps,
      latestBlog = _ref5.latestBlog,
      ctaSection = _ref5.ctaSection,
      emailSignupBox = _ref5.emailSignupBox,
      workOfflineSection = _ref5.workOfflineSection,
      logic = _ref5.logic;

  var _useState = (0,react.useState)(false),
      showPricePredictionModal = _useState[0],
      setShowPricePredictionModal = _useState[1];

  var startingStack = (0,esm_react/* useAtomValue */.Dv)(calculator/* startingStackAtom */.$_);

  var allInputsData = pages_objectSpread(pages_objectSpread({}, inputsData), {}, {
    startingStack: startingStack
  });

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(seo/* default */.Z, pages_objectSpread({}, seoData)), /*#__PURE__*/(0,jsx_runtime.jsx)(logicContext/* LogicContext.Provider */.u.Provider, {
      value: logic,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Form, {
        onSubmit: function onSubmit() {},
        validate: function validate(values) {
          var sharingValidation = {};
          if (values.useStackingAmount) return pages_objectSpread(pages_objectSpread({}, sharingValidation), {}, {
            currentStack: validateCurrentStack(values, startingStack, {
              satsLimit: logic.SatsSupplyLimit,
              BTCLimit: logic.BTCSupplyLimit,
              currentStack: startingStack
            })
          });
          return pages_objectSpread({
            goal: (0,goal/* validateGoal */.h)(values, allInputsData, {
              satsLimit: logic.SatsSupplyLimit,
              BTCLimit: logic.BTCSupplyLimit,
              currentStack: startingStack
            }),
            currentStack: validateCurrentStack(values, startingStack, {
              satsLimit: logic.SatsSupplyLimit,
              BTCLimit: logic.BTCSupplyLimit,
              currentStack: startingStack,
              checkGoal: true
            })
          }, sharingValidation);
        },
        children: function children(_ref6) {
          var values = _ref6.values;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Box */.xu, {
              flex: true,
              align: "center",
              marginBottom: 5,
              marginBottomSmDown: 3,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(pageTitle/* default */.Z, {
                title: heroData.heading,
                description: values.useStackingAmount ? heroData.descriptionPredictByInvestment : heroData.descriptionPredictByGoal,
                $marginBottom: 0
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* Box */.xu, {
              flex: true,
              justifyContent: "center",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledComposition, {
                areas: areasMobile,
                areasSm: areasTablet({
                  ctaSection: ctaSection
                }),
                areasXl: areasDesktop({
                  ctaSection: ctaSection
                }),
                gapCol: 3,
                paddingHorizontalLg: 2,
                templateColsSm: "1fr 1fr 1fr 1fr",
                templateRowsSm: "repeat(min-content)",
                templateColsXl: "25% 1fr 1fr",
                maxWidth: '1500px',
                flexGrow: '1',
                height: "100%",
                children: function children(_ref7) {
                  var Inputs = _ref7.Inputs,
                      SummaryText = _ref7.SummaryText,
                      BitcoinValue = _ref7.BitcoinValue,
                      SingleStats = _ref7.SingleStats,
                      Graph = _ref7.Graph,
                      TableOutput = _ref7.TableOutput,
                      EmailSignup = _ref7.EmailSignup,
                      LatestBlog = _ref7.LatestBlog,
                      CallToAction = _ref7.CallToAction;
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [showPricePredictionModal && /*#__PURE__*/(0,jsx_runtime.jsx)(Modal, {
                      title: allInputsData.predictionsModalTitle,
                      onClose: function onClose() {
                        (0,utils/* enableScroll */.K9)();
                        setShowPricePredictionModal(false);
                      },
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PredictionInputs, {
                        inputsData: allInputsData
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Calculation, {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SummaryText, {
                        flex: true,
                        justifyContent: "center",
                        maxWidth: "calc(100vw - 2rem)",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SummaryTextComponent, {
                          byGoalSummaryText: outputsProps.byGoalSummaryText,
                          byInvestmentAmountSummaryText: outputsProps.byInvestmentAmountSummaryText
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(BitcoinValue, {
                        flex: true,
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        justifyContentSm: "center",
                        maxWidth: "calc(100vw - 2rem)",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(BitcoinValueBox, {})
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Inputs, {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(GlassBox, {
                          padding: "1rem 1rem 0 1rem",
                          minHeight: "auto",
                          height: "100%",
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CalculatorInputs, {
                            workOfflineSection: workOfflineSection,
                            inputsData: allInputsData,
                            showPricePredictionModal: showPricePredictionModal,
                            setShowPricePredictionModal: setShowPricePredictionModal
                          })
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SingleStats, {
                        maxWidth: "calc(100vw - 2rem)",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SingleStatsComponent, {
                          singleStatsProps: outputsProps.singleStats
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Graph, {
                        maxWidth: "calc(100vw - 2rem)",
                        flex: true,
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(GraphsComponent, {
                          graphProps: outputsProps.graphs,
                          graphToggleProps: outputsProps.graphToggle
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TableOutput, {
                        maxWidth: "calc(100vw - 2rem)",
                        marginTopXsDown: -1,
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TableComponent, {
                          tableProps: outputsProps.table
                        })
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(EmailSignup, {
                      flex: true,
                      justifyContentMd: "center",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(EmailSignupComponent, pages_objectSpread({
                        isFullWidth: false
                      }, emailSignupBox))
                    }), latestBlog && /*#__PURE__*/(0,jsx_runtime.jsx)(LatestBlog, {
                      id: "scrollbar-blogs",
                      style: {
                        overflowX: 'scroll'
                      },
                      flex: true,
                      width: "100%",
                      justifyContentXl: "start",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LatestBlogComponent, {
                        blogs: latestBlog
                      })
                    }), !!(ctaSection !== null && ctaSection !== void 0 && ctaSection.visible) && /*#__PURE__*/(0,jsx_runtime.jsx)(CallToAction, {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTAComponent, pages_objectSpread({}, ctaSection))
                    })]
                  });
                }
              })
            })]
          });
        }
      })
    })]
  });
}

/***/ }),

/***/ 72583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ai": function() { return /* binding */ convertValue; },
/* harmony export */   "Fd": function() { return /* binding */ toSat; },
/* harmony export */   "Xn": function() { return /* binding */ onToggle; },
/* harmony export */   "Zx": function() { return /* binding */ SATOSHI_FACTOR; },
/* harmony export */   "mg": function() { return /* binding */ toBTC; }
/* harmony export */ });
/* harmony import */ var decimal_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90482);
/* harmony import */ var _currency__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92442);


var SATOSHI_FACTOR = 100000000;
var convertValue = function convertValue(previousIsSatoshi, newIsSatoshi, value) {
  if (newIsSatoshi === true && previousIsSatoshi === false) {
    return value * SATOSHI_FACTOR;
  }

  if (newIsSatoshi === false && previousIsSatoshi === true) {
    return value / SATOSHI_FACTOR;
  }

  return value;
};
var onToggle = function onToggle(form, previousIsSatoshi, newIsSatoshi) {
  var _form$getState = form.getState(),
      goal = _form$getState.values.goal;

  form.change('goal', convertValue(previousIsSatoshi, newIsSatoshi, goal));
};
var toSat = function toSat(val) {
  var _Decimal;

  if (val === '') return '';
  if (!val) return '0';
  return (0,_currency__WEBPACK_IMPORTED_MODULE_1__/* .scientificToNumber */ .L9)((_Decimal = new decimal_js__WEBPACK_IMPORTED_MODULE_0__/* .Decimal */ .t(val)) === null || _Decimal === void 0 ? void 0 : _Decimal.mul(SATOSHI_FACTOR).toNumber()).toString();
};
var toBTC = function toBTC(val) {
  if (val === '') return '';
  if (!val) return '0';
  return (0,_currency__WEBPACK_IMPORTED_MODULE_1__/* .scientificToNumber */ .L9)(new decimal_js__WEBPACK_IMPORTED_MODULE_0__/* .Decimal */ .t(val).dividedBy(SATOSHI_FACTOR).toNumber()).toString();
};

/***/ }),

/***/ 92442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hh": function() { return /* binding */ formatWithLetters; },
/* harmony export */   "L9": function() { return /* binding */ scientificToNumber; },
/* harmony export */   "LH": function() { return /* binding */ CurrencyInput; },
/* harmony export */   "cQ": function() { return /* binding */ getLocaleCurrency; },
/* harmony export */   "ij": function() { return /* binding */ getUnitName; },
/* harmony export */   "jK": function() { return /* binding */ getCurrencySymbol; },
/* harmony export */   "jN": function() { return /* binding */ toAbbreviatedCurrencyString; },
/* harmony export */   "mr": function() { return /* binding */ toCurrencyString; },
/* harmony export */   "x6": function() { return /* binding */ numberWithCommas; }
/* harmony export */ });
/* unused harmony export getCoincapCurrencyCode */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16835);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4730);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81531);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90607);
/* harmony import */ var components_atoms_form__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6427);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);





var _excluded = ["maximumSignificantDigits"],
    _excluded2 = ["currency"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, void 0, groups); }; var _super = RegExp.prototype, _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = new RegExp(re, flags); return _groups.set(_this, groups || _groups.get(re)), (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_this, BabelRegExp.prototype); } function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { return groups[name] = result[g[name]], groups; }, Object.create(null)); } return (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); return result && (result.groups = buildGroups(result, this)), result; }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if ("string" == typeof substitution) { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { return "$" + groups[name]; })); } if ("function" == typeof substitution) { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = arguments; return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args); }); } return _super[Symbol.replace].call(this, str, substitution); }, _wrapRegExp.apply(this, arguments); }





var stripLettersFromSymbol = function stripLettersFromSymbol(str) {
  return str.replace( /*#__PURE__*/_wrapRegExp(/^(\x2D)?(US|A|CA|JP)+/g, {
    sign: 1
  }), '$<sign>');
};

var formatValueToCurrencyString = function formatValueToCurrencyString(value, currency, options) {
  var _value$toLocaleString;

  return (_value$toLocaleString = value.toLocaleString(undefined, _objectSpread({
    style: 'currency',
    currency: currency
  }, options))) !== null && _value$toLocaleString !== void 0 ? _value$toLocaleString : '';
};

var toCurrencyString = function toCurrencyString(value) {
  var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'USD';
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (value === null || value === undefined || value === '' || isNaN(value)) {
    return '';
  }

  var _options$maximumFract = options.maximumFractionDigits,
      maximumFractionDigits = _options$maximumFract === void 0 ? 2 : _options$maximumFract;
  var calcVal = Number(value); // Add check for -0

  if (Object.is(calcVal, -0)) {
    calcVal = 0;
  }

  if (calcVal > -(1 / Math.pow(10, maximumFractionDigits)) && calcVal < 0) {
    calcVal = 0;
  }

  var outString = formatValueToCurrencyString(calcVal, currency, options);
  return stripLettersFromSymbol(outString);
};

var toSigFigsRounded = function toSigFigsRounded(num, divisor, suffixLetter, maximumSignificantDigits) {
  var adjusted = Number(num.toPrecision(maximumSignificantDigits || 3)) / divisor;
  return "".concat(adjusted.toLocaleString(undefined, {
    maximumFractionDigits: 2
  })).concat(suffixLetter);
};

var formatWithLetters = function formatWithLetters(num) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var maximumSignificantDigits = _ref.maximumSignificantDigits,
      other = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_ref, _excluded);

  if (num >= 1000000000000) {
    return toSigFigsRounded(num, 1000000000000, 'T', maximumSignificantDigits);
  }

  if (num >= 1000000000) {
    return toSigFigsRounded(num, 1000000000, 'B', maximumSignificantDigits);
  }

  if (num >= 1000000) {
    return toSigFigsRounded(num, 1000000, 'M', maximumSignificantDigits);
  }

  if (num >= 1000) {
    return toSigFigsRounded(num, 1000, 'k', maximumSignificantDigits);
  }

  return num.toLocaleString(undefined, _objectSpread({
    maximumSignificantDigits: maximumSignificantDigits
  }, other));
};
var toAbbreviatedCurrencyString = function toAbbreviatedCurrencyString(value, currency) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var normalValue = toCurrencyString(value, currency, options);
  var formatted = formatWithLetters(value, options);
  if (formatted) return normalValue.replace(/[\d.,]+/g, formatted);
  return normalValue;
};
var getLocaleCurrency = function getLocaleCurrency(defaultCurrency) {
  if (true) {
    if (window.navigator.language === 'en-GB') return 'GBP';
  }

  return defaultCurrency || 'USD';
};
function getCurrencySymbol(currency) {
  return stripLettersFromSymbol(0 .toLocaleString(undefined, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).replace(/\d/g, '').trim());
}
var CurrencyInput = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4__.forwardRef(function (_ref2, ref) {
  var currency = _ref2.currency,
      props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_ref2, _excluded2);

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_4__.useState(false),
      _React$useState2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_React$useState, 2),
      hasChanged = _React$useState2[0],
      setHasChanged = _React$useState2[1];

  var handleFocus = function handleFocus(e) {
    if (!hasChanged) {
      e.target.value = '';
    }
  };

  var handleBlur = function handleBlur(e) {
    if (!hasChanged && e.target.value === '') {
      e.target.value = props.defaultValue;
    }
  };

  var handleChange = function handleChange(e) {
    setHasChanged(true);

    if (props.onChange) {
      props.onChange(e);
    }

    setHasChanged(false);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(components_atoms_form__WEBPACK_IMPORTED_MODULE_3__.FormattedInput, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    onFocus: handleFocus,
    onBlur: handleBlur,
    onChange: handleChange,
    format: function format(val) {
      return val !== '' ? toCurrencyString(val, currency) : getCurrencySymbol(currency);
    },
    leftContentEditing: getCurrencySymbol(currency),
    step: 0.01
  }));
});
function numberWithCommas(x) {
  if (isNaN(x)) return x;
  var parts = x.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
}
function getUnitName(amount, isSatoshis) {
  if (isSatoshis) {
    if (amount == 1) {
      return 'sat';
    }

    return 'sats';
  } else {
    return 'BTC';
  }
}
function scientificToNumber(num) {
  return Number(num).toFixed(8).replace(/\.?0+$/, '');
}
var currencySymbolsToCoincapIds = {
  'USD': 'united-states-dollar',
  'GBP': 'british-pound-sterling',
  'EUR': 'euro',
  'JPY': 'japanese-yen',
  'AUD': 'australian-dollar',
  'CAD': 'canadian-dollar'
};
function getCoincapCurrencyCode(currencySymbol) {
  return currencySymbolsToCoincapIds[currencySymbol];
}

/***/ }),

/***/ 73839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useLogic; },
/* harmony export */   "u": function() { return /* binding */ LogicContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var LogicContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
var useLogic = function useLogic() {
  return react__WEBPACK_IMPORTED_MODULE_0__.useContext(LogicContext);
};

/***/ }),

/***/ 91851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G8": function() { return /* binding */ sentenceCase; },
/* harmony export */   "HV": function() { return /* binding */ colorFromValue; },
/* harmony export */   "K9": function() { return /* binding */ enableScroll; }
/* harmony export */ });
/* unused harmony export disableScroll */
var sentenceCase = function sentenceCase(string) {
  var lowCase = string.toLowerCase();
  var capitalize = lowCase[0].toUpperCase() + lowCase.slice(1);
  return capitalize;
};
var colorFromValue = function colorFromValue(number) {
  if (number > 0) return '#7DD346';
  if (number < 0) return '#D0342C';
  return 'inherit';
};
function enableScroll() {
  document.body.classList.remove("stop-scrolling");
}
function disableScroll() {
  document.body.classList.add("stop-scrolling");
}

/***/ }),

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(74956);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [937,546,234,309,262,889,334,427,774,888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);